/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Secondary_Goal_LongInputs */

const en_us2_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When two exercises fit the slot, this decides.`)
};

const pt_br2_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando dois exercícios cabem na vaga, isto decide.`)
};

const es_419_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando dos ejercicios caben en el lugar, esto decide.`)
};

const pt_pt2_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando dois exercícios cabem no mesmo lugar, isto decide.`)
};

const fr_fr2_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand deux exercices conviennent pour une place, c'est lui qui tranche.`)
};

const de_de2_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn zwei Übungen auf den Platz passen, entscheidet das hier.`)
};

const it_it2_intake_why_secondary_goal_long = /** @type {(inputs: Intake_Why_Secondary_Goal_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando due esercizi vanno bene per lo stesso posto, decide questo.`)
};

/**
* | output |
* | --- |
* | "When two exercises fit the slot, this decides." |
*
* @param {Intake_Why_Secondary_Goal_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_secondary_goal_long = /** @type {((inputs?: Intake_Why_Secondary_Goal_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Secondary_Goal_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_secondary_goal_long(inputs)
	if (locale === "es-419") return es_419_intake_why_secondary_goal_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_secondary_goal_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_secondary_goal_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_secondary_goal_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_secondary_goal_long(inputs)
	return en_us2_intake_why_secondary_goal_long(inputs)
});
export { intake_why_secondary_goal_long as "intake.why.secondary_goal.long" }